// iOS WebKit does not reliably dispatch a delegated click for a tap on a
// non-interactive element. Base UI deliberately uses a delegated click for
// backdrop dismissal so a drag that ends outside the popup does not close it.
// Giving the rendered backdrop a native onclick property keeps Base UI's
// intentional-press semantics while making an ordinary iOS tap reach it.
const noop = () => {};

export function makeBackdropClickableOnIOS(
  element: HTMLDivElement | null,
): void {
  if (element != null && element.onclick == null) {
    element.onclick = noop;
  }
}
